import { render } from "./test.vue?vue&type=template&id=18d38513&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"

import "./test.vue?vue&type=style&index=0&id=18d38513&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/frontend-offical-website/master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d38513"]])

export default __exports__